import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 11v6l-5 -4l-5 4v-6l5 -4l5 4","key":"svg-0"}]]

/**
 * IconArrowBadgeUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctYmFkZ2UtdXAiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDExdjZsLTUgLTRsLTUgNHYtNmw1IC00bDUgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-badge-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowBadgeUp = createReactComponent('outline', 'arrow-badge-up', 'ArrowBadgeUp', __iconNode);

export default IconArrowBadgeUp;